export default "__VITE_ASSET__d5b8e3d9__"